import { render, staticRenderFns } from "./editBtn.vue?vue&type=template&id=00843572&scoped=true&"
import script from "./editBtn.vue?vue&type=script&lang=js&"
export * from "./editBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00843572",
  null
  
)

export default component.exports